import { REQUEST_USER_INITIATE_QLE_REENROLLMENT } from './initiate-qle-reenrollment.action-types';

export const requestInitiateQLE = payload => ({
  type: REQUEST_USER_INITIATE_QLE_REENROLLMENT,
  payload,
});
